<template>
	<div class="page">
		<header>
			<h1>
				Surface
				<br />habitable
			</h1>
		</header>
		<article>
			<div class="counter">
				<div class="moins" @click="decrement()">-</div>
				<div class="count">
					{{surface_habitable}}
					<span>
						m
						<sup>2</sup>
					</span>
				</div>
				<div class="plus" @click="increment()">+</div>
			</div>
		</article>
		<footer>
			<router-link to="/architecture" class="button back">
				<i class="fa fa-angle-left"></i>
			</router-link>
			<router-link v-if="ready && $store.state.terrain == 'Plat'" to="/finition" class="button medium">
				Niveau de finition
				<i class="fa fa-angle-right"></i>
			</router-link>
			<router-link
				v-if="ready && $store.state.terrain == 'En pente'"
				to="/soussol"
				class="button medium"
			>
				Sous-sol
				<i class="fa fa-angle-right"></i>
			</router-link>
		</footer>
	</div>
</template>
<script>
	export default {
		name: "Surface",
		components: {},
		data() {
			return {
				ready: true
			};
		},
		computed: {
			surface_habitable() {
				return this.$store.state.surface;
			}
		},
		methods: {
			decrement() {
				this.$store.commit("setSurface", this.surface_habitable - 5);
				if (this.surface_habitable <= 5) {
					this.$store.commit("setSurface", 0);
				} else {
					this.$store.commit(
						"setSurface",
						this.surface_habitable - 5
					);
				}
			},
			increment() {
				if (this.surface_habitable >= 500) {
					this.$store.commit("setSurface", 500);
				} else {
					this.$store.commit(
						"setSurface",
						this.surface_habitable + 5
					);
				}
			}
		},
		mounted() {
			this.$store.commit("setTimer", 60);
		}
	};
</script>

<style lang="less">
	.counter {
		display: flex;
		align-items: center;
		.plus,
		.moins {
			font-weight: bold;
			color: black;
			font-size: 180px;
			padding: 50px;
			outline: none;
		}
		.count {
			width: 400px;
			height: 400px;
			color: black;
			background: white;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			text-align: center;
			font-size: 160px;
			font-weight: bold;
			line-height: 180px;
			span {
				font-size: 60px;
				padding-left: 20px;
				padding-top: 70px;
			}
		}
	}
</style>